import React from 'react';
import { PieChart as RePieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

const PieChart = ({ data, title, colors }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) return null;
    const point = payload[0];
    return (
      <div
        style={{
          backgroundColor: '#ffffff',
          border: '1px solid #e5e7eb',
          borderRadius: '12px',
          color: '#000',
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
          padding: '10px 12px'
        }}
      >
        <div style={{ color: '#111827', fontWeight: 700 }}>{`${point.name}: ${point.value}`}</div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm h-full flex flex-col overflow-hidden">
      <h3 className="text-[#FF8C00] font-bold mb-4 text-center text-lg uppercase tracking-wide min-h-[56px] flex items-center justify-center">{title}</h3>
      <div className="h-[280px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <RePieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius="58%"
              outerRadius="78%"
              paddingAngle={data.length > 1 ? 4 : 0}
              dataKey="value"
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              verticalAlign="bottom" 
              height={44}
              iconType="circle"
              formatter={(value) => <span style={{ color: '#4B5563', fontSize: '12px', fontWeight: '500', marginLeft: '6px' }}>{value}</span>}
            />
          </RePieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PieChart;